/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { AuthConfiguration, IptvLoginResponse } from 'client-code/iptv-login';

import { IptvLoginServiceRepositoryImpl } from '../impls/IptvLoginServiceRepositoryImpl';
import { IIptvLoginServiceRepository } from '../interfaces/IIptvLoginServiceRepository';

export class IptvLoginService implements IIptvLoginServiceRepository {
    private oIptvLoginServiceRepository: IptvLoginServiceRepositoryImpl;

    public constructor() {
        this.oIptvLoginServiceRepository = new IptvLoginServiceRepositoryImpl();
    }

    public static initialize(baseUrl: string, whiny?: boolean) {
        IptvLoginServiceRepositoryImpl.initialize(baseUrl, whiny);
    }

    public async fetchAndGetAuthConfiguration(): Promise<AuthConfiguration> {
        return this.oIptvLoginServiceRepository.fetchAndGetAuthConfiguration();
    }

    public async getIptvLoginBySamlToken(samlToken: string): Promise<IptvLoginResponse> {
        return this.oIptvLoginServiceRepository.getIptvLoginBySamlToken(samlToken);
    }
}
